@let translateParamsValue = translateParams();
@let errorMessagesValue = errorMessages();
@let warningMessagesValue = warningMessages();
@let successMessagesValue = successMessages();
@if (errorMessagesValue.length > 0) {
  <cfp-alert [alertStyle]="'danger'" [icon]="'info-circle'" [iconAriaLabel]="'Error'" [hasAccent]="true">
    @for (error of errorMessagesValue; track error; let i = $index) {
      <div [class.mt-3]="i > 0">
        {{ error | translate: translateParamsValue }}
      </div>
    }
  </cfp-alert>
}
@if (warningMessagesValue.length > 0) {
  <cfp-alert [alertStyle]="'warning'" [icon]="'info-circle'" [iconAriaLabel]="'Warning'" [hasAccent]="true">
    @for (error of warningMessagesValue; track error; let i = $index) {
      <div [class.mt-3]="i > 0">
        {{ error | translate: translateParamsValue }}
      </div>
    }
  </cfp-alert>
}
@if (successMessagesValue.length > 0) {
  <cfp-alert [alertStyle]="'success'" [icon]="'check'" [iconAriaLabel]="'Success'" [hasAccent]="true">
    @for (success of successMessagesValue; track success; let i = $index) {
      <div [class.mt-3]="i > 0">
        {{ success | translate: translateParamsValue }}
      </div>
    }
  </cfp-alert>
}
